<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="customer"
      item-key="objectId"
      :loading="loading"
      :search="search"
      class="border-2 dataTable row-pointer data-table-customer"
      @click:row="viewProfile"
      :items-per-page="50"
      :no-data-text="$t('noinfo')"
      :no-results-text="$t('no_matching_records_found')"
    >
      <template v-slot:item.contractLabel="{ item }">
        <div>
          <template v-for="contract in item.contracts">
            <template v-if="contract.contractId">
              <span class="block p-1 m-1 text-sm border rounded-md bg-gray-50"
                >{{ contract.contractId }}
                <span class="mx-1 text-sm" v-if="contract.stallType"
                  >({{
                    contract.stallType ? $t(`contact.stall_type.${contract.stallType}`) : '-'
                  }})</span
                ></span
              >
            </template>
          </template>
        </div>
      </template>

      <template v-slot:header.companyName="{header}">
        <div class="text-nowrap-table text-center" style="min-width:190px">{{header.text}}</div>
      </template>
      <template v-slot:header.fullName="{header}">
        <div class="text-nowrap-table text-center" style="min-width:190px;">{{header.text}}</div>
      </template>

      <template v-slot:item.companyName="{ item }">
        <div class="text-truncate business-name">
          {{item.companyName}}
        </div>
      </template>
      <template v-slot:item.fullName="{ item }">
        <div class="text-truncate customer-name">
          {{item.fullName}}
        </div>
      </template>
      <template v-slot:item.emails="{ item }">
        <div style="max-width: 300px">
          <template v-for="email in item.emails">
            <span class="block p-1 m-1 text-sm border rounded-md bg-gray-50">{{
              email
            }}</span>
          </template>
        </div>
      </template>
      <template v-slot:item.tels="{ item }">
        <div style="max-width: 300px">
          <template v-if="item.interTels.filter(tel => tel && tel != '-').length">
            <template v-for="tel in item.interTels">
              <span class="block p-1 m-1 text-sm border rounded-md bg-gray-50">{{ $helper.telToString([tel]) || "-" }}</span>
            </template>
          </template>
          <template v-else>
            <template v-for="tel in item.tels">
              <span class="block p-1 m-1 text-sm border rounded-md bg-gray-50">{{ $helper.telToString([tel]) || "-" }}</span>
            </template>
          </template>
        </div>
      </template>
      <template v-slot:item.view="{ item }">
        <v-btn color="primary" text @click="viewProfile(item)"
          ><v-icon>mdi-eye</v-icon></v-btn
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Customer",
  created() {
    this.headers = [
      { text: this.$t('bill.customer_market_id'), value: "customerMarketId" },
      { text: this.$t('contract.title'), value: "contractLabel" },
      { text: this.$t('customer.company_name_title'), value: "companyName", width: '1%', class: 'custom-sort', align: 'center hd-resize text-truncate' },
      { text: this.$t('market.marchant_name'), value: "fullName", width: '1%', class: 'custom-sort', align: 'center hd-resize text-truncate' },
      { text: this.$t('account.email_address'), value: "emails" },
      { text: this.$t('login.phone_number'), value: "tels" },
      { text: "", value: "view" },
    ]
  },
  computed: {
    ...mapGetters({
      customer: "customer/getCustomers",
    }),
  },
  
  data() {
    return {
      loading: false,
      headers: [],
    };
  },
  props: {
    search: String,
  },
  mounted() {},
  methods: {
    viewProfile(obj) {
      this.$router.push(obj.objectId + "/view");
    },
  },
};
</script>

<style lang="scss" scoped>

.data-table-customer::v-deep td.hd-resize{
  max-width: 190px;
}

.data-table-customer::v-deep th.custom-sort {
  position: relative;
  .v-icon{
    position: absolute;
    right: 30px;
    top: 15px;
  }
}

.text-start {
  border-right: 1px solid #eee;
}
.v-data-table::v-deep th {
  color: #000;
  font-size: 1rem !important;
  text-align: center !important;
}
.v-data-table::v-deep td {
  font-size: 1rem !important;
  text-align: center !important;
  padding-right: 2rem !important;
}

.row-cursor tbody tr:hover {
  cursor: pointer;
}
</style>
